require.register("modules/mil/a01/page-10/page-10", function(exports, require, module){
  var BaseExtension = require('base-extension');
var _ = window._ || require('lodash');

var page_10 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {
    onComplete();
  }
}, BaseExtension);

module.exports = page_10;


  
});

